const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']

export default function bytesToSize(bytes, size = 'Byte') {
  if (!bytes) return null
  if (bytes === 0) return `0 ${size}`
  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))
  return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i]
}

